import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CorporateAccountService, GeneralService, IUser } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { noPastDateValidator } from '../../pages/assisted-booking/validator';
@Component({
  selector: 'app-extra-service-rental',
  templateUrl: './extra-service-rental.component.html',
  styleUrls: ['./extra-service-rental.component.scss']
})
export class ExtraServiceRentalComponent implements OnInit {
   private toastState = {
  startPast: false,
};
  user: IUser | undefined
  otherFacilitiesData = {
    form: { label: 'Amenities', placeholder: 'Amenities' },
    caption: 'Enter Amenities'
  }
  amenities: [{name: '', label: '', checked: false}]

  form = new FormGroup({
    location: new FormControl('', [Validators.required]),
    properties_type: new FormControl('', [Validators.required]),
    number_of_bedroom: new FormControl('', [Validators.required]),
    move_in_date: new FormControl('', [Validators.required, noPastDateValidator()]),
    duration: new FormControl('', [Validators.required, noPastDateValidator()]),
    additional_requests: new FormControl('', []),
    amenities: new FormControl([]),
  });
  locationName: any;
  booking: any;

  loading: boolean = false
  minDate: any;
  endDate: any;

  constructor(
    public bsModalRef: BsModalRef,
    private options: ModalOptions,
    private service: CorporateAccountService,
    private toastr: ToastrService,
    private gs: GeneralService,

  ) { }

  ngOnInit(): void {
    // console.log(this.options)
    this.booking = this.options.initialState?.booking
     const ctrlStart = this.form.get('move_in_date');
     const ctrlEnd = this.form.get('duration');

    ctrlStart?.valueChanges.subscribe(() => {
      if (ctrlStart.hasError('pastDate')) {
        if (!this.toastState.startPast) {
          this.toastr.error(
            'No past date allowed. Please enter the current date or a future date.'
          );
          this.toastState.startPast = true;
          this.form.get('move_in_date')?.setValue('');
        }
      } else {
        this.toastState.startPast = false;
      }
    });
    ctrlEnd?.valueChanges.subscribe(() => {
      if (ctrlEnd.hasError('pastDate')) {
        if (!this.toastState.startPast) {
          this.toastr.error(
            'No past date allowed. Please enter the current date or a future date.'
          );
          this.toastState.startPast = true;
          this.form.get('duration')?.setValue('');
        }
      } else {
        this.toastState.startPast = false;
      }
    });
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
  }

  
  getDate(event: any) {
    this.endDate = event.value;
  }

  locationChangeF({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.location.setValue(s);

  }

  locationChangeT({ latlng, s }: any) {
    // const location = latlng.join(',')
    this.locationName = s;
    this.form.controls.to.setValue(s);

  }

  getRemovedRule(event: string) {
    this.amenities.some((element: {name: string, checked: boolean}) => {
      if (element.name.includes(event)) {
        element.checked = false
      }
    })
  }

  submit() {
    this.loading = true
    const {location, properties_type, amenities, additional_requests, number_of_bedroom, move_in_date, duration } = this.form.value;

    const payload = {
      location,
      property_type: properties_type,
      additional_requests,
      number_of_bedrooms: number_of_bedroom,
      move_in_date,
      duration,
      amenities,
      employee: this.user?.id || this.user?._id,
      business: this.user?.business?.id || this.user?.business?._id,
      booking: this.booking

    }
    if (this.booking !== null) {
      this.service.createExtraServiceRental(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })
    } else {
      delete payload.booking

      this.service.createExtraServiceRental(payload).subscribe((res: any) => {
          this.toastr.success(res.message)
          this.bsModalRef.hide()
      }, err => {
        this.toastr.error(this.gs.getErrMsg(err));
        this.loading = false

        // this.bsModalRef.hide()
      })
    }
  }

}
